var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ms-5"},[_c('div',[_c('h2',{staticClass:"pt-5 pb-5"},[_vm._v("Visa/Master Card")]),(_vm.message)?_c('h5',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),(_vm.error)?_c('h5',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }